import { Settings } from 'luxon';

const localisation = {
    state: {
        locale: 'en-GB',
        timeZone: 'Europe/London'
    },
    getters: {
        getLocale(state) {
            return state.locale;
        },
        getTimeZone(state) {
            return state.timeZone;
        }
    },
    mutations: {
        setLocale(state, locale) {
            state.locale = locale;
        },
        setTimeZone(state, timeZone) {
            state.timeZone = timeZone;
        }
    },
    actions: {
        setCurrentLocale({ commit }, locale) {
            if (locale) {
                commit('setLocale', locale);

                Settings.defaultLocale = locale;
            }
        },
        setCurrentTimeZone({ commit }, timeZone) {
            if (timeZone) {
                commit('setTimeZone', timeZone);

                Settings.defaultZone = timeZone;
            }
        }
    }
};

export default localisation;
